import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/page/login'
// import home from '@/components/common/Home'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',        //首页
      name: 'login',
      component: login,
      // meta:{isLogin: false}
      meta:{needClearUser: true}
    },
    {
    	path: '/home',     //默认主界面
    	name: 'home',
    	component: resolve => require(['../components/common/Home.vue'], resolve),
      children:[
        {
          path: 'shops',     //门店列表页面
          name: 'shops',
          component: resolve => require(['../components/page/shops.vue'], resolve),
          // meta:{rootPermission: true}
        },
        {
          path: 'shop/:storeId',      //门店页面
          name: 'shop',
          component: resolve => require(['../components/common/shop.vue'], resolve),
          children:[
            {
              path:'overview',   //概览页面
              name:'overview',
              component: resolve => require(['../components/page/overview.vue'], resolve),
              meta:{dataLimit:true}
            },
            {
              path:'products',   //商品页面
              name:'products',
              component: resolve => require(['../components/page/products.vue'], resolve),
              meta:{dataLimit:true}
            },
            {
              path:'label',      //标签页面
              name:'label',
              component: resolve => require(['../components/page/label.vue'], resolve),
              meta:{dataLimit:true}
            },
            {
              path:'gateway',    //网关页面
              name:'gateway',
              component: resolve => require(['../components/page/gateway.vue'], resolve),
              meta:{dataLimit:true}
            },
            {
              path:'record',     //记录页面
              name:'record',
              component: resolve => require(['../components/page/record.vue'], resolve),
              meta:{dataLimit:true}
            },
            // {
            //   path:'authorization',    //授权页面
            //   name:'authorization',
            //   component: resolve => require(['../components/page/authorization.vue'], resolve),
            //   meta:{dataLimit:true}
            // },
            {
              path:'shopsTemplates',    //模板列表页面
              name:'shopsTemplates',
              component: resolve => require(['../components/page/templates.vue'], resolve),
              meta:{dataLimit:true, viewPermi: true}
            },
            {
              path: 'shopTemplate/:demoId',   //模板页面
              name: 'shopTemplate',
              component: resolve => require(['../components/page/template.vue'], resolve),
              meta:{dataLimit:true, viewPermi: true}
            },
            {
              path: 'import',   //导入页面
              name: 'import',
              component: resolve => require(['../components/page/import.vue'], resolve),
              meta:{dataLimit:true}
            },
            {
              path:'settings',    //设置页面
              name:'settings',
              component: resolve => require(['../components/page/settings.vue'], resolve),
              meta:{adminPermission: true}
            },
            {
              path:'errorCode',     //错误码（隐藏页面）
              name:'errorCode',
              component: resolve => require(['../components/page/errorCode.vue'], resolve),
              meta:{rootPermission: true}
            }
          ]
        },
        {
          path: 'system',     //系统页面
          name: 'system',
          component: resolve => require(['../components/page/system.vue'], resolve),
          meta:{rootPermission: true}
        },
        {
          path: 'templates',   //模板列表页面
          name: 'templates',
          component: resolve => require(['../components/page/templates.vue'], resolve),
          meta:{rootPermission: true}
        },
        {
          path: 'template/:demoId',   //模板页面
          name: 'template',
          component: resolve => require(['../components/page/template.vue'], resolve),
          meta:{rootPermission: true}
        },
        {
          path: 'personInfo',   //个人信息页面
          name: 'personInfo',
          component: resolve => require(['../components/page/personInfo.vue'], resolve)
        }
      ]
    },
    {
      path: '/404',
      name: 'nofound',
      component : resolve => require(['../components/page/404.vue'], resolve),
      meta: {isErrPage: true}
    },
    {
      path: '/error',
      name: 'error',
      component : resolve => require(['../components/page/error.vue'], resolve),
      meta: {isErrPage: true}
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js